import { SystemIcon } from '@volvo/vcdk-react/SystemIcon';

import { AreaName } from 'domain/constants';
import { TabConfiguration } from 'library/components/controls/layout/tabs/types';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';
import { ProductIndividual_Services_Repairs } from 'main/routes/urls/RouteUrls';

export const productIndividualServicesAreaTabsConfiguration: TabConfiguration[] =
	[
		{
			title: 'productIndividual:repairs-title',
			path: ProductIndividual_Services_Repairs,
			icon: <SystemIcon icon="wrench" aria-label="Repairs" />,
			areaSecurity: createArea(AreaName.Repair, OperationType.Read),
		},
	];
